mutation PurchaseOrderCopy($input: PurchaseOrderCopyInput!) {
  purchaseOrderCopy(input: $input) {
    newPurchaseOrder
  }
}
